import { PageHeader } from '@verantos-dev/shared-components';

import { useDataReliabilityPageHeader } from '../hooks/useDataReliabilityPageHeader';

const DataReliabilityPageHeader = () => {
  const { breadcrumbs, pageTabs, messages } = useDataReliabilityPageHeader();

  return (
    <PageHeader
      id="cohortsListPageHeader"
      pageTitle={messages.pageTitle}
      breadcrumbs={breadcrumbs}
      pageTabs={pageTabs}
      titleBelowTabs={messages.accuracyTitle} // Only accuracy tab is active
      descriptionBelowTabs={messages.accuracyDesc} // Only accuracy tab is active
    />
  );
};

export default DataReliabilityPageHeader;
